export class ColorCodes {
  colorIndicators: { label: string; color: string }[] = [
      { label: 'Assigned', color: '#d3d2d2' },
      { label: 'Grade Not Released', color: '#ffa6026b' },
      { label: 'Graded', color: '#ccf8cc' },
      { label: 'Sent Back', color: '#fafaa9' },
      { label: 'Ungraded', color: '#f8dde2' }
    ];

}

export enum StatusLabel{
    Graded = 'Graded',
    GradeNotReleased = 'Grade Not Released',
    SentBack = 'Sent Back',
    Assigned = 'Assigned',
    Ungraded = 'Ungraded',
    NotStarted = 'Not Started' // no attempt id
}

export enum CSSLabel{
    Graded = 'Graded',
    GradeNotReleased = 'GradeNotReleased',
    SentBack = 'SentBack',
    Assigned = 'Assigned',
    Ungraded = 'Ungraded',
    NotStarted = 'NotStarted'
}

export enum UserIconColors{
   '#9ad3ff',
   '#ffbf9a',
   '#fff29a',
   '#e29aff'
}
